import React from 'react';

interface BottomActionsProps {
    children: React.ReactNode;
    className?: string;
    contentClassName?: string;
}

//This component is used to wrap content placed at the bottom of containers (usually buttons)
const BottomActions = ({
    children,
    className = '',
    contentClassName = '',
}: BottomActionsProps) => {
    return (
        <div
            className={`fixed bottom-0 left-0 right-0 bg-white p-3 border-t border-gray-200 z-20 ${className}`}
        >
            <div className={`flex w-full items-center ${contentClassName}`}>
                {children}
            </div>
        </div>
    );
};

export default BottomActions;
